export function fadeOut({
  element,
  duration = 300,
  onComplete,
}: {
  element: string | HTMLDivElement;
  duration?: number;
  onComplete?: () => void;
}): Promise<void> {
  const el: HTMLDivElement | null = typeof element === 'string' ? document.querySelector(element) : element;

  if (!el) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    el.style.opacity = '0.3';
    el.style.transition = `opacity ${duration}ms linear`;

    setTimeout(() => {
      el.style.display = 'none';
      onComplete?.();
      resolve();
    }, duration);
  });
}
